export default "__VITE_ASSET__BUznkKA7__"